import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const AddPostFile = (props) => {
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [lead, setLead] = useState("");
  const [inputs, setInputs] = useState({});
  const [user, setUser] = useState([]);
  const [fileType, setFileType] = useState("sell");

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const getData = async () => {
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    setLoading(true);
    uploadFilesArray.map(async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("idEnvelope", props.idEnvelope);

      await fetch("https://apidevkppp.ftpeople.pl/uploadPostFile", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "pliki",
          }).then((result) => {
            props.close();
          });
        })
        .catch((error) => {});
    });
  };

  return (
    <>
      <div
        style={{ width: "50vw", position: "fixed" }}
        className="mainContainerAddTransaction"
      >
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <>
              <input multiple={false} type="file" onChange={changeFiles} />
              <>
                <div
                  style={{ marginTop: "0", marginBottom: "5vh" }}
                  className="inputBox"
                ></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                      <table
                        style={{ width: "100%", boxSizing: "border-box" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                    <div style={{ marginTop: "2vh" }}>
                      <button
                        style={{ width: "15%" }}
                        className="refreshButton"
                        onClick={sendFiles}
                      >
                        Wyślij
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default AddPostFile;
